module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkin-google-map",
    attrs: {
      "name": "hres6oe-check-in-out"
    }
  }, [_c('div', {
    staticClass: "place-box"
  }, [_c('div', {
    staticClass: "select-place-box with-scroll"
  }, [_vm._l((_vm.workPlaceData), function(dataRow, index) {
    return _c('div', {
      key: index,
      staticClass: "select-place",
      on: {
        "click": function($event) {
          _vm.checkedPlace(index)
        }
      }
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "building-detail"
    }, [_c('div', {
      staticClass: "building-name"
    }, [_vm._v("\n            " + _vm._s(dataRow.title) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "building-location"
    }, [_vm._v("\n            " + _vm._s(dataRow.address) + "\n          ")])]), _vm._v(" "), ((_vm.lastCheckIn.codcust === dataRow.codcust && _vm.lastCheckIn.flg_inout === 'I' && _vm.lastCheckIn === 'N') || index === _vm.selected) ? _c('i', {
      staticClass: "ion-checkmark check-place",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e()])
  }), _vm._v(" "), _c('input', {
    ref: "custNewLatLngPopup",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#hres6oe-cust-latlng",
      "type": "hidden"
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "select-place-box"
  }, [_c('div', {
    staticClass: "select-place",
    on: {
      "click": function($event) {
        _vm.callCustNewLatLngList()
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "building-detail"
  }, [_c('div', {
    staticClass: "other"
  }, [_vm._v("\n            " + _vm._s(this.custNewLatLngSelected.length > 0 ? this.custNewLatLngSelected[0].namcust : _vm.label['HRES6OEC2']['70']) + "\n          ")])]), _vm._v(" "), (_vm.workPlaceData.length + 2 === _vm.selected) ? _c('i', {
    staticClass: "ion-checkmark check-place",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('cust-new-lat-lng', {
    attrs: {
      "labels": _vm.label,
      "data": _vm.placeNewLatLng,
      "flgClearFilterLocation": _vm.flgClearFilterLocation,
      "holdFilterLocation": _vm.holdFilterLocation,
      "placeNewLatLngColumns": _vm.placeNewLatLngColumns,
      "setCustNewLatLngSelected": _vm.setCustNewLatLngSelected,
      "receivedCheckInPlaceNoLocation": _vm.receivedCheckInPlaceNoLocation
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "select-place",
    on: {
      "click": function($event) {
        _vm.checkedPlace(_vm.workPlaceData.length + 1)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "building-detail"
  }, [_c('div', {
    staticClass: "other"
  }, [_vm._v("\n            " + _vm._s(_vm.label['HRES6OEC2']['10']) + "\n          ")])]), _vm._v(" "), (_vm.workPlaceData.length + 1 === _vm.selected) ? _c('i', {
    staticClass: "ion-checkmark check-place",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "checkin-input-box"
  }, [((_vm.lastCheckIn.typplace === '3' && _vm.lastCheckIn.flg_inout === 'I' && _vm.isLastChkInInArea) || _vm.workPlaceData.length + 1 === _vm.selected) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.label['HRES6OEC2']['40']) + " "), _c('span', {
    staticClass: "text-red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.new_namcust),
      expression: "detail.new_namcust"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "normal-input",
    attrs: {
      "type": "text",
      "data-vv-name": "new_namcust",
      "name": "input",
      "maxlength": "45",
      "has-error": _vm.errors.has('new_namcust')
    },
    domProps: {
      "value": (_vm.detail.new_namcust)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "new_namcust", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('new_namcust')),
      expression: "errors.has('new_namcust')"
    }],
    staticClass: "validator-text -error"
  }, [_vm._v(_vm._s(_vm.errors.first('new_namcust')))])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.label['HRES6OEC2']['50']) + " "), _c('span', {
    staticClass: "text-red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.namcontact),
      expression: "detail.namcontact"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "normal-input",
    attrs: {
      "type": "text",
      "data-vv-name": "namcontact",
      "name": "input",
      "maxlength": "45",
      "has-error": _vm.errors.has('namcontact')
    },
    domProps: {
      "value": (_vm.detail.namcontact)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "namcontact", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('namcontact')),
      expression: "errors.has('namcontact')"
    }],
    staticClass: "validator-text -error"
  }, [_vm._v(_vm._s(_vm.errors.first('namcontact')))])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.label['HRES6OEC2']['60']) + " "), _c('span', {
    staticClass: "text-red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.phone),
      expression: "detail.phone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "normal-input",
    attrs: {
      "type": "text",
      "data-vv-name": "phone",
      "name": "input",
      "maxlength": "30",
      "has-error": _vm.errors.has('phone')
    },
    domProps: {
      "value": (_vm.detail.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('phone')),
      expression: "errors.has('phone')"
    }],
    staticClass: "validator-text -error"
  }, [_vm._v(_vm._s(_vm.errors.first('phone')))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.label['HRES6OEC2']['20']) + " "), _c('span', {
    staticClass: "text-red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('hrms-dropdown', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.dropdowns,
      "data-vv-value-path": "inputValue",
      "data-vv-name": "codreason",
      "has-error": _vm.errors.has('codreason')
    },
    model: {
      value: (_vm.detail.codreason),
      callback: function($$v) {
        _vm.$set(_vm.detail, "codreason", $$v)
      },
      expression: "detail.codreason"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('codreason')),
      expression: "errors.has('codreason')"
    }],
    staticClass: "validator-text -error"
  }, [_vm._v(_vm._s(_vm.errors.first('codreason')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.label['HRES6OEC2']['30']) + " "), _c('span', {
    staticClass: "text-red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.activity),
      expression: "detail.activity"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:500'),
      expression: "'required|max:500'"
    }],
    staticClass: "normal-input",
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "type": "text",
      "maxlength": "500",
      "data-vv-name": "activity",
      "name": "input",
      "has-error": _vm.errors.has('activity')
    },
    domProps: {
      "value": (_vm.detail.activity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "activity", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('activity')),
      expression: "errors.has('activity')"
    }],
    staticClass: "validator-text -error"
  }, [_vm._v(_vm._s(_vm.errors.first('activity')))]), _vm._v(" "), _c('div', {
    staticClass: "remark-limit-character"
  }, [_vm._v(_vm._s(_vm.dispLimitLabel(500)))])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "label"
  }, [_c('i', {
    staticClass: "fa fa-camera"
  }), _vm._v(" " + _vm._s(_vm.label['HRES6OEC2']['80']) + " "), _c('span', {
    staticClass: "text-red"
  }, [_vm._v("*")])]), _vm._v(" "), (_vm.detail.filenamei && _vm.pathImage) ? _c('div', {
    staticClass: "checkin-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.pathImage + _vm.detail.filenamei
    }
  })]) : _vm._e(), _vm._v(" "), (this.typButton === 'O') ? _c('div', [_c('hrms-dropzone', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "hrmsDropzoneChkIn",
    attrs: {
      "fileNameQuery": _vm.detail.filenamei,
      "prefixFileName": _vm.currentUser.p_codempid,
      "capture": 'HAF',
      "flgToggle": _vm.detailDisp,
      "name": 'imageChkIn',
      "maxFileSizeInMB": 20,
      "acceptedFileTypes": 'image/*',
      "resizeWidth": 600,
      "data-vv-value-path": "inputValue",
      "data-vv-name": "filenamei",
      "has-error": _vm.errors.has('filenamei')
    },
    model: {
      value: (_vm.detail.filenamei),
      callback: function($$v) {
        _vm.$set(_vm.detail, "filenamei", $$v)
      },
      expression: "detail.filenamei"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('filenamei')),
      expression: "errors.has('filenamei')"
    }],
    staticClass: "validator-text -error"
  }, [_vm._v(_vm._s(_vm.errors.first('filenamei')))])], 1) : _vm._e()]), _vm._v(" "), (this.typButton === 'I') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "label"
  }, [_c('i', {
    staticClass: "fa fa-camera"
  }), _vm._v(" " + _vm._s(_vm.label['HRES6OEC2']['90']) + " "), _c('span', {
    staticClass: "text-red"
  }, [_vm._v("*")])]), _vm._v(" "), (_vm.detail.filenameo && _vm.pathImage) ? _c('div', {
    staticClass: "checkin-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.pathImage + _vm.detail.filenameo
    }
  })]) : _vm._e(), _vm._v(" "), _c('hrms-dropzone', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "hrmsDropzoneChkOut",
    attrs: {
      "fileNameQuery": _vm.detail.filenameo,
      "prefixFileName": _vm.currentUser.p_codempid,
      "capture": 'HAF',
      "flgToggle": _vm.detailDisp,
      "name": 'imageChkOut',
      "maxFileSizeInMB": 20,
      "acceptedFileTypes": 'image/*',
      "resizeWidth": 600,
      "data-vv-value-path": "inputValue",
      "data-vv-name": "filenameo",
      "has-error": _vm.errors.has('filenameo')
    },
    model: {
      value: (_vm.detail.filenameo),
      callback: function($$v) {
        _vm.$set(_vm.detail, "filenameo", $$v)
      },
      expression: "detail.filenameo"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('filenameo')),
      expression: "errors.has('filenameo')"
    }],
    staticClass: "validator-text -error"
  }, [_vm._v(_vm._s(_vm.errors.first('filenameo')))])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "button-md",
    class: (_vm.typButton === 'I' ? '_bg-orange' : '_bg-green') + ' ' + (_vm.pcDisp ? '' : '-mobile'),
    on: {
      "click": function($event) {
        _vm.callSave()
      }
    }
  }, [_vm._v(_vm._s(_vm.typButton === 'I' ? 'Check Out' : 'Check In'))]), _vm._v(" "), _c('div', {
    staticClass: "button-md _bg-grey",
    class: _vm.pcDisp ? '' : '-mobile',
    on: {
      "click": function($event) {
        _vm.callBack()
      }
    }
  }, [_vm._v("Cancel")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "color-icon _bg-red"
  }, [_c('i', {
    staticClass: "fa fa-building -icon-building"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "color-icon _bg-blue"
  }, [_c('i', {
    staticClass: "fa fa-building -icon-building"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "color-icon"
  }, [_c('i', {
    staticClass: "fa fa-building -icon-building"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0ce7f45a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres6oe/checkInOut.vue
// module id = 3553
// module chunks = 1